import React from "react";
import styled from "styled-components";

// components
import PricingLink from "core/SiteHeader/components/PricingLink.js";
import LoginButton from "core/SiteHeader/components/LoginButton.js";

//styles
import { UnstyledListItemStyled } from "core/SiteHeader/styles.js";
const UnauthMenuStyled = styled.nav`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const UlStyled = styled.ul`
    display: flex;
    align-items: center;
`;

// component
const UnauthMenu = ({ onFocusScroll, isDisabled = false }) => {
    return (
        <UnauthMenuStyled>
            <UlStyled>
                <PricingLink onFocus={onFocusScroll} isDisabled={isDisabled} />
                <UnstyledListItemStyled>
                    <LoginButton
                        onFocus={onFocusScroll}
                        isDisabled={isDisabled}
                    />
                </UnstyledListItemStyled>
            </UlStyled>
        </UnauthMenuStyled>
    );
};

export default UnauthMenu;

import PropTypes from "prop-types";

// prop-types
UnauthMenu.propTypes = {
    onFocusScroll: PropTypes.func,
    isDisabled: PropTypes.bool
};
